import React, { useEffect, useRef } from "react";
import cssClasses from "./Help.module.css";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import CancellationPolicy from "../CancellationPolicy/CancellationPolicy";
import ContactUs from "../ContactUs/ContactUs";
import AboutUs from "../AboutUs/AboutUs";
export default function Help() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.activeMenu("help"));
	}, []);

	const [value, setValue] = React.useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<div className={cssClasses.wrapperPage}>
			<Box sx={{ width: "100%", typography: "body1" }} display={"flex"} flexDirection={"column"} flex={"1"} overflow={"hidden"}>
				<TabContext value={value}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<TabList onChange={handleChange} variant="scrollable">
							<Tab
								style={{ fontFamily: "Inter-Medium", fontStyle: "normal", fontWeight: "500", fontSize: "1.4rem", lineHeight: "2rem" }}
								label="Terms & Policies"
								value="1"
							/>
							<Tab
								style={{ fontFamily: "Inter-Medium", fontStyle: "normal", fontWeight: "500", fontSize: "1.4rem", lineHeight: "2rem" }}
								label="Contact Us"
								value="2"
							/>
							<Tab
								style={{ fontFamily: "Inter-Medium", fontStyle: "normal", fontWeight: "500", fontSize: "1.4rem", lineHeight: "2rem" }}
								label="About Us"
								value="3"
							/>
						</TabList>
					</Box>
					<TabPanel value="1" className={cssClasses.helpContentData}>
						<div className={cssClasses.policyStack}>
							<PrivacyPolicy />
							<TermsAndConditions />
							<CancellationPolicy />
						</div>
					</TabPanel>
					<TabPanel value="2" className={cssClasses.helpContentData}>
						<ContactUs />
					</TabPanel>
					<TabPanel value="3" className={cssClasses.helpContentData}>
						<AboutUs />
					</TabPanel>
				</TabContext>
			</Box>
		</div>
	);
}
